var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"engText"},[_vm._v(_vm._s(_vm.engText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }